<template>
    <div>
        <fieldset>
            <div class="row">
                <legend>Shipping Information</legend>
            </div>
            <div class="row">
                <div class="small-12 columns lp">
                    <labeled-input autocomplete="name" label="Practice Name *" name="Company Name" v-model='sampleobject.name'></labeled-input>
                </div>
            </div>
            <div class="row">
                <labeled-input label="Address Line 1 (no P.O. boxes please) *" name="Address line 1" v-model='sampleobject.addressLine1'></labeled-input>
            </div>
            <div class="row">
                <labeled-input validation="" label="Address Line 2" name="Address line 2" v-model='sampleobject.addressLine2'></labeled-input>
            </div>
            <div class="row">
                <div class="medium-7 columns lp">
                    <labeled-input label="City *" name="City" v-model='sampleobject.city'></labeled-input>
                </div>
                <div class="medium-2 columns lp">
                    <div :class="{'error': errors.has('State / Region') }">
                        <label for="region">State / Region *</label>
                        <input id="region" type="text" v-validate="'required|min:2'" name="State / Region" class="full-txt" maxlength="2" placeholder="" v-model='sampleobject.region'>
                        <p class="error" v-if="errors.has('State / Region')">{{ errors.first('State / Region') }}</p>
                    </div>
                </div>
                <div class="medium-3 columns lp end">
                    <labeled-input validation="required|regex:^\d{5}(?:[-\s]\d{4})?$" label="Postal Code *" name="Postal Code" v-model='sampleobject.postalCode'></labeled-input>
                </div>
            </div>
            <div class="row">
              <div class="medium-6 columns lp">
                  <div :class="{'error': errors.has('Telephone') }">
                      <label for="telephone">Office Phone Number *</label>
                      <input id="telephone" @blur="formatShippingPhoneNumber()" type="text" v-validate="'required'" name="Telephone" class="full-txt" placeholder="" v-model='sampleobject.phone'>
                      <p class="error" v-if="errors.has('Telephone')">{{ errors.first('Telephone') }}</p>
                  </div>
              </div>
              <div class="medium-6 columns lp">
                  <div :class="{'error': errors.has('Mobile Phone') || errorMessage }">
                      <label for="mobilephone">
                          Personal Cell Number
                          *
                      </label>
                      <div class="input-container">
                          <input id="mobilephone" @blur="formatShippingMobilePhoneNumber()" type="text" v-validate="'required'" name="Mobile Phone" class="full-txt number" placeholder="" v-model='sampleobject.mobilePhone'>
                      </div>
                      <small class="small-text text-blue">Please ensure that the cell information provided is your personal number and not your office contact information.</small>
                      <p class="error" v-if="errors.has('Mobile Phone') || errorMessage">{{ errors.first('Mobile Phone') || errorMessage }}</p>
                  </div>
              </div>
            </div>
            <div class="row">
                <div class="medium-8 columns lp">
                    <labeled-input validation="required|email" label="Email *" name="Email" autocomplete="on" v-model='sampleobject.email' @change="validateEmail"></labeled-input>
                    <small class="duplicate-error" v-if="hasNoSupplier" v-html="supplierNotFoundMessage"></small>
                    <small class="duplicate-error" v-if="hasInvalidGeoInfo" v-html="invalidGeoInfo"></small>
                    <small class="duplicate-error" v-if="hasInvalidEmail" v-html="invalidEmail"></small>
                    <small class="duplicate-error" v-if="hasDuplicateOrder1" v-html="duplicateOrderMessage1"></small>
                    <small class="duplicate-error" v-if="hasDuplicateOrder2" v-html="duplicateOrderMessage2"></small>
                    <small class="duplicate-error" v-if="hasDuplicateOrder3" v-html="duplicateOrderMessage3"></small>
                </div>
            </div>
        </fieldset>
    </div>
</template>
<script>
import LabeledInput from "@/components/shared/LabeledInput";

export default {
  props: ["sampleobject"],
  inject: ["$validator"],
  components: { LabeledInput },
  data() {
    return {
      timeOutTimer: null,
      hasDuplicateOrder1: false,
      hasDuplicateOrder2: false,
      hasDuplicateOrder3: false,
      hasInvalidGeoInfo: false,
      hasInvalidEmail: false,
     duplicateOrderMessage1: `Our records indicate that you have already ordered a <strong>Transitions<sup>&reg;</sup> GEN S<sup>&trade;</sup> Evaluation Product</strong>. 
        Essilor has determined that it is reasonable to offer all eligible employees of professional eyecare practices with only one (1) pair of Transitions<sup>&reg;</sup> GEN S<sup>&trade;</sup> lenses. 
        For more details, please contact your sales representative.`,
      duplicateOrderMessage2: `Essilor has determined that it is reasonable to offer all eligible employees professional eyecare practices with only limited evaluation products. For more details, please contact your sales representative.`,
      duplicateOrderMessage3: `Our records indicate that you have already ordered this particular combination of Essilor products. 
	Essilor has determined that it is reasonable to offer all eligible employees of professional eyecare practices with only one (1) pair of lenses with these specific attributes. 
	For more details, please contact your sales representative.`,
      invalidGeoInfo: ` Invalid Geo information. `,
      invalidEmail: `This portal is strictly for employees of professional eyecare practices in a customer-facing role like opticians, optometrists, ophthalmologists, technicians, and eyewear consultants. `,
      errorMessage: '',
      showInfo: false,
      supplierNotFoundMessage: 'Missing lab to process.',
      hasNoSupplier: false
    };
  },
  computed: {
    duplicateOrderHasUpdate() {
      const { firstName, lastName, email, couponCode, mobilePhone, treatment, design, photochromic, material } = this.sampleobject;
      return {
        firstName,
        lastName,
        email,
        couponCode,
        mobilePhone,
        design,
        treatment,
        photochromic,
        material,
      };
    }
  },
  methods: {
    validate() {
      this.$validator.validateAll();
    },
    formatShippingPhoneNumber() {
      this.sampleobject.phone = this.formatPhoneNumber(this.sampleobject.phone);
    },
    formatShippingMobilePhoneNumber() {
      this.sampleobject.mobilePhone = this.formatPhoneNumber(this.sampleobject.mobilePhone, 'mobilePhone');
    },
    formatPhoneNumber(args, type = 'telephone') {
      var s2 = ("" + args).replace(/\D/g, "");
      var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (type === 'mobilePhone' && !m) {
        this.errorMessage = "The Mobile Phone field must be 10 digits.";
        return args;
      }
      else this.errorMessage = ""
      return !m ? null : m[1] + "-" + m[2] + "-" + m[3];
    },
    checkDuplicateOrder() {
      const {
        firstName,
        lastName,
        email,
        couponCode,
        mobilePhone,
        treatment,
        photochromic,
        material,
        design,
      } = this.sampleobject;
      if (!firstName || !lastName || !email || !mobilePhone || !treatment || !photochromic || !material || !design) return;
      axios
        .get(`/order?firstname=${firstName}&lastname=${lastName}&email=${email}&coupon=${couponCode}&mobilephone=${mobilePhone}&treatment=${treatment}&design=${design}&material=${material}&photochromic=${photochromic}`)
        .then((response) => {
          const responseList = response.data.split('|')
          const duplicateOrderResponse = responseList[0]
          if (duplicateOrderResponse.toLowerCase() === "ok") {
            this.hasDuplicateOrder1 = false;
            this.hasDuplicateOrder2 = false;
            this.hasDuplicateOrder3 = false;
            this.$emit('hasDuplicateOrder1', false)
            this.$emit('hasDuplicateOrder2', false)
            this.$emit('hasDuplicateOrder3', false)
          }
        })
        .catch((error) => {
          const errorList = error.response.data.split('|')
          const duplicateOrderResponse = errorList[0]
          const legacyOrderResponse = errorList[1]
          
          if (duplicateOrderResponse.toLowerCase() === "duplicate detected" && legacyOrderResponse.toLowerCase() === "false") {
            this.hasDuplicateOrder1 = true;
            this.$emit('hasDuplicateOrder1', true)
          }
          if (duplicateOrderResponse.toLowerCase() === "duplicate detected" && legacyOrderResponse.toLowerCase() === "true") {
            this.hasDuplicateOrder2 = true;
            this.hasDuplicateOrder3 = false;
            this.$emit('hasDuplicateOrder2', true)
            this.$emit('hasDuplicateOrder3', false)
          }
          if (duplicateOrderResponse.toLowerCase() === "already ordered" && legacyOrderResponse.toLowerCase() === "true") {
            this.hasDuplicateOrder3 = true;
            this.hasDuplicateOrder2 = false;
            this.$emit('hasDuplicateOrder3', true)
            this.$emit('hasDuplicateOrder2', false)
          }
          if (duplicateOrderResponse.toLowerCase() === "geo tag id not found") {
            this.hasInvalidGeoInfo = true;
            this.$emit('hasInvalidGeoInfo', true)
          }
          if (duplicateOrderResponse.toLowerCase() === "supplier not found") {
          this.hasNoSupplier = true;
          this.$emit('hasNoSupplier', true)
        }
        });
    },
    validateEmail(email) {
      const emailFiltered = email;
      // Check if email is undefined or null
      if (emailFiltered == null) {
        return;
      }

      if (emailFiltered.includes("@essilorusa.com") || emailFiltered.includes("@essilorluxottica.com") || 
        emailFiltered.includes("@essilor.com") || emailFiltered.includes("@luxottica.com")) {
      if (this.sampleobject.programType == 'Employee' || this.sampleobject.programType == 'SalesRep') {
          this.hasInvalidEmail = false;
        } else {
          this.hasInvalidEmail = true;
        }
      } else {
        this.hasInvalidEmail = false;
      }
      this.$emit('hasInvalidEmail', this.hasInvalidEmail);
    }
  },
  created() {
    this.formatShippingPhoneNumber();
    if (this.sampleobject.mobilePhone)
      this.formatShippingMobilePhoneNumber();
  },
  watch: {
    duplicateOrderHasUpdate: {
      handler: function(data) {
        const { firstName, lastName, email, mobilePhone, treatment, photochromic, design, material } = data;
        if (!!firstName && !!lastName && !!email && !!mobilePhone && !!treatment && !!photochromic && !!design && !!material) {
          clearTimeout(this.timeOutTimer);
          this.timeOutTimer = setTimeout(() => {
            this.checkDuplicateOrder();
          }, 1000);
        }
      },
      deep: true
    },
  'sampleobject.email': {
    handler: function(email) {
      this.validateEmail(email);
    },
    immediate: true // Trigger the handler immediately when the component is created
  }
  }
};
</script>
<style>
.duplicate-error {
    color: red;
}
.note {
  color: red;
  font-weight: bold;
  font-size: 11px;
}
</style>
